import styled, { css } from 'styled-components';
import { TabsContainer } from '../TabsContainer';
import { StyledTabLine } from '../TabsContainer/TabsContainer.styled';
import { Text } from '../Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	width: 100%;
	height: 40px;
	user-select: none;
`;

const StyledTabsWrapper = styled.div`
	position: relative;
	flex: 1;
	min-width: 0;
	height: 40px;
`;

const StyledTabs = styled(TabsContainer)`
	width: 100%;
	gap: 10px;

	${StyledTabLine} {
		display: none;
	}
`;

const StyledFade = styled.div<{ $color: string }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 40px;
	height: 40px;
	pointer-events: none;
	background: linear-gradient(to left, ${({ $color }) => $color}, transparent);
`;

const StyledTab = styled.div<{ $selected?: boolean }>`
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 40px;
	padding: 0 9px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.05);
	cursor: pointer;
	transition:
		background-color 0.3s ease,
		border-color 0.3s ease;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		line-height: normal;
		white-space: nowrap;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;
		border-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${Text} {
			color: #000000;
		}
	}

	${({ $selected }) =>
		$selected &&
		css`
			background-color: #2d70da;
			border-color: #2d70da;

			&:hover {
				background-color: #2d70da;
				border-color: #2d70da;

				img {
					filter: none;
				}

				${Text} {
					color: #ffffff;
				}
			}
		`}
`;

export {
	StyledContainer,
	StyledFade,
	StyledTab,
	StyledTabs,
	StyledTabsWrapper,
};
